import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/stations';

class stationService {
    createStation(Station) {
        return axios.post(API_URL, Station);
    }

    getAllStations() {
        return axios.get(API_URL);
    }

    getStationById(id) {
        return axios.get(`${API_URL}/${id}`);
    }

    updateStation(id, updatedStation) {
        return axios.put(`${API_URL}/${id}`, updatedStation);
    }

    deleteStation(id) {
        return axios.delete(`${API_URL}/${id}`);
    }
}

export default new stationService();
